import React, { ReactNode } from "react";
import Tooltip from "@adsk/alloy-react-tooltip";
import SelectBox from "@adsk/alloy-select-box";
import TextInput from "@adsk/alloy-react-text-input";
import { ConditionalTooltip } from "@adsk/acc-issues-common/components/primitive/ConditionalTooltip";
import {
  FieldWrapper,
  FieldWrapperProps,
} from "@adsk/acc-issues-common/components/primitive/FieldWrapper";
import { useTranslations } from "@adsk/acc-issues-translations";

export enum PermissionedFieldTypes {
  Text = "text",
  Dropdown = "dropdown",
}

export const DisabledInputComponent = ({
  type,
}: {
  type: PermissionedFieldTypes;
}) => {
  const { T } = useTranslations();
  const placeholder = T.translate("issueBulkEdit.disabledField") as string;

  if (type === PermissionedFieldTypes.Dropdown) {
    return <SelectBox disabled={true} placeholder={placeholder} />;
  }
  if (type === PermissionedFieldTypes.Text) {
    return <TextInput value={placeholder} disabled={true} />;
  }
  return <></>;
};

export const PermissionedField = ({
  hasPermission,
  fieldWrapperProps,
  type,
  children,
}: {
  hasPermission: boolean | undefined;
  fieldWrapperProps: Omit<FieldWrapperProps, "children">;
  type: PermissionedFieldTypes;
  children: ReactNode;
}) => {
  const { T } = useTranslations();

  return (
    <ConditionalTooltip
      placement={Tooltip.PLACEMENTS.BOTTOM}
      style={{ maxWidth: 300 }}
      content={T.translate("issueBulkEdit.noPermissionsForField")}
      condition={!hasPermission}
    >
      <FieldWrapper {...fieldWrapperProps}>
        {!hasPermission ? <DisabledInputComponent type={type} /> : children}
      </FieldWrapper>
    </ConditionalTooltip>
  );
};
